"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistributorPOEmailTemplate = exports.buildDistributorPOTable = void 0;
exports.buildDistributorPOTable = (distributorInventories, siteName, siteAddress, accountNumber, note, 
// shippingMethod: { id?: number; method?: string; distributor?: string }
shippingMethod) => {
    const table = document.createElement("TABLE");
    table.style.cssText =
        "border-collapse: collapse;mso-table-lspace: 0pt;mso-table-rspace: 0pt;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;border-spacing: 0;width: 100%;border: 1px solid #ddd;";
    table.setAttribute("class", "po-table");
    // create table head
    const tableRowHead = document.createElement("TR");
    const tableHeadPkgCode = document.createElement("TH");
    tableHeadPkgCode.style.cssText =
        "background-color: #e9ebf1;padding: 10px;text-align: left;";
    const tableHeadName = document.createElement("TH");
    tableHeadName.style.cssText =
        "background-color: #e9ebf1;padding: 10px;text-align: left;";
    const tableHeadQuantity = document.createElement("TH"); // C-022.11
    tableHeadQuantity.style.cssText =
        "background-color: #e9ebf1;padding: 10px;text-align: left;";
    const tableHeadPrice = document.createElement("TH"); // C-022.11
    tableHeadPrice.style.cssText =
        "background-color: #e9ebf1;padding: 10px;text-align: left;";
    const tableHeadTotalCost = document.createElement("TH"); // C-022.11
    tableHeadTotalCost.style.cssText =
        "background-color: #e9ebf1;padding: 10px;text-align: left;";
    // const tableHeadQuantity = document.createElement("TH");
    // tableHeadQuantity.style.cssText =
    //   "text-align: right;background-color: #e9ebf1;padding: 10px;";
    // tableHeadQuantity.style.textAlign = "right";
    tableHeadPkgCode.appendChild(document.createTextNode("Package Code")); // C-022
    tableHeadName.appendChild(document.createTextNode("Name")); // C-022
    tableHeadQuantity.appendChild(document.createTextNode("Quantity")); // C-022.11
    tableHeadPrice.appendChild(document.createTextNode("Price")); // C-022.11
    tableHeadTotalCost.appendChild(document.createTextNode("Total Cost")); // C-022.11
    tableRowHead.appendChild(tableHeadPkgCode);
    tableRowHead.appendChild(tableHeadName);
    tableRowHead.appendChild(tableHeadQuantity); // C-022.11
    tableRowHead.appendChild(tableHeadPrice); // C-022.11
    tableRowHead.appendChild(tableHeadTotalCost); // C-022.11
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }); //C-022.151
    // Append table head to table element
    table.appendChild(tableRowHead);
    for (const inventory of distributorInventories) {
        const { id: inventoryId, name, poNumber, pkgCode, inventoryOrderQuantity: quantity, price, inventoryTotalCost } = inventory; // C-022.11
        // Create table row and append table data
        const tableRow = document.createElement("TR");
        const tableDataPkgCode = document.createElement("TD");
        tableDataPkgCode.style.cssText =
            "mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;padding: 5px 10px;";
        const tableDataName = document.createElement("TD");
        tableDataName.style.cssText =
            "mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;padding: 5px 10px;";
        const tableDataQuantity = document.createElement("TD"); // C-022.11
        tableDataQuantity.style.cssText =
            "mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;padding: 5px 10px;";
        const tableDataInventoryPrice = document.createElement("TD"); // C-022.11
        tableDataInventoryPrice.style.cssText =
            "mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;padding: 5px 10px;";
        const tableDataTotalPrice = document.createElement("TD"); // C-022.11
        tableDataTotalPrice.style.cssText =
            "mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;padding: 5px 10px;";
        tableDataPkgCode.appendChild(document.createTextNode(pkgCode));
        tableDataName.appendChild(document.createTextNode(name));
        tableDataQuantity.appendChild(document.createTextNode(String(quantity))); // C-022.11
        tableDataInventoryPrice.appendChild(document.createTextNode(formatter.format(price))); // C-022.11 C-022.15 C-022.151
        tableDataTotalPrice.appendChild(document.createTextNode(formatter.format(inventoryTotalCost))); // C-022.11 C-022.15 C-022.151
        tableRow.appendChild(tableDataPkgCode);
        tableRow.appendChild(tableDataName);
        tableRow.appendChild(tableDataQuantity); // C-022.11
        tableRow.appendChild(tableDataInventoryPrice); // C-022.11
        tableRow.appendChild(tableDataTotalPrice); // C-022.11
        table.appendChild(tableRow);
    }
    let totalInventoriesCount = 0;
    distributorInventories.forEach(inventory => (totalInventoriesCount += inventory.inventoryOrderQuantity));
    /**
     * C-022.15 have some modification to add Total qty and cost start from L-108 to L-145 table.appendChild(tableRow);
     */
    let sumOfallInventoryTotalCost = 0;
    distributorInventories.forEach(inventory => (sumOfallInventoryTotalCost += inventory.inventoryTotalCost));
    const tableRow = document.createElement("TR");
    const tableDataPkgCode = document.createElement("TH");
    tableDataPkgCode.style.cssText =
        "mso-line-height-rule: exactly;-ms-text-size-adjust: 100%; background-color: #e9ebf1; -webkit-text-size-adjust: 100%;padding: 5px 10px;";
    const tableDataName = document.createElement("TH");
    tableDataName.style.cssText =
        "mso-line-height-rule: exactly;-ms-text-size-adjust: 100%; background-color: #e9ebf1; -webkit-text-size-adjust: 100%;padding: 5px 10px;";
    const tableDataQuantity = document.createElement("TH"); // C-022.11
    tableDataQuantity.style.cssText =
        "mso-line-height-rule: exactly;-ms-text-size-adjust: 100%; background-color: #e9ebf1; -webkit-text-size-adjust: 100%;padding: 5px 10px;";
    const tableDataInventoryPrice = document.createElement("TH"); // C-022.11
    tableDataInventoryPrice.style.cssText =
        "mso-line-height-rule: exactly;-ms-text-size-adjust: 100%; background-color: #e9ebf1; -webkit-text-size-adjust: 100%;padding: 5px 10px;";
    const tableDataTotalPrice = document.createElement("TH"); // C-022.11
    tableDataTotalPrice.style.cssText =
        "mso-line-height-rule: exactly;-ms-text-size-adjust: 100%; background-color: #e9ebf1; -webkit-text-size-adjust: 100%;padding: 5px 10px;";
    ;
    tableDataPkgCode.appendChild(document.createTextNode("Total"));
    tableDataName.appendChild(document.createTextNode(''));
    tableDataQuantity.appendChild(document.createTextNode(String(totalInventoriesCount))); // C-022.11  C-022.15
    tableDataInventoryPrice.appendChild(document.createTextNode('')); // C-022.11 C-022.15
    tableDataTotalPrice.appendChild(document.createTextNode(formatter.format(sumOfallInventoryTotalCost))
    // document.createTextNode(String(`$${sumOfallInventoryTotalCost.toFixed(2)}`))
    ); // C-022.11 C-022.15
    tableRow.appendChild(tableDataPkgCode);
    tableRow.appendChild(tableDataName);
    tableRow.appendChild(tableDataQuantity); // C-022.11
    tableRow.appendChild(tableDataInventoryPrice); // C-022.11
    tableRow.appendChild(tableDataTotalPrice); // C-022.11
    table.appendChild(tableRow);
    return `
    <div class="tldr">
      <div class="summary-shipping">
        <div>
          <h3 class="tldr-title" style="display: block;margin: 0;padding: 0;">Summary</h3>
          <div class="tldr-content" style="margin: 0 25px;">
            <p style="margin: 10px 0;padding: 0;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;">PO #: ${distributorInventories.length &&
        distributorInventories[0].poNumber
        ? distributorInventories[0].poNumber
        : ""}</p>
            <p style="margin: 10px 0;padding: 0;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;">Distinct Inventory Count: ${distributorInventories.length}</p>
            <p style="margin: 10px 0;padding: 0;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;">Total Inventory Count: ${totalInventoriesCount}</p>
            <p style="margin: 10px 0;padding: 0;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;">Pharmacy Name: ${siteName}</p>
            <p style="margin: 10px 0;padding: 0;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;">Pharmacy Address: ${siteAddress}</p>
            <p style="margin: 10px 0;padding: 0;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;">Account Number: ${accountNumber}</p>
          </div>
         </div>
         <div>
            <h3 class="tldr-title" style="display: block;margin: 0;padding: 0;">Shipping Request</h3>
            <div class="tldr-content" style="margin: 0 25px;">
              ${shippingMethod
        ? `<p style="margin: 10px 0;padding: 0;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;">${shippingMethod.distributor}: ${shippingMethod.method}</p> `
        : ``}
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
    <br />
    ${table.outerHTML}
  `;
};
/**
 *   C-022.15 remove order note as per the ticket, removed the div in L-140
 *   <div>
      <h3 class="tldr-title" style="display: block;margin: 0;padding: 0;">Order Note:</h3>
      <p>${note}</p>
      <br />
    </div>
 * @param subject
 * @param title
 * @param body
 * @returns
 */
exports.getDistributorPOEmailTemplate = (subject, title, body) => `<!doctype html>
<html>
    <head>
      <!-- NAME: HERO CARD -->
        <!--[if gte mso 15]>
    <xml>
      <o:OfficeDocumentSettings>
      <o:AllowPNG/>
      <o:PixelsPerInch>96</o:PixelsPerInch>
      </o:OfficeDocumentSettings>
    </xml>
    <![endif]-->
    <meta charset="UTF-8">
        <meta http-equiv="X-UA-Compatible" content="IE=edge">
        <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>${subject}</title>

    <style type="text/css">
    p{
      margin:10px 0;
      padding:0;
    }
    table{
      border-collapse:collapse;
    }
    h1,h2,h3,h4,h5,h6{
      display:block;
      margin:0;
      padding:0;
    }
    img,a img{
      border:0;
      height:auto;
      outline:none;
      text-decoration:none;
    }
    body,#bodyTable,#bodyCell{
      height:100%;
      margin:0;
      padding:0;
      width:100%;
    }
    .mcnPreviewText{
      display:none !important;
    }
    #outlook a{
      padding:0;
    }
    img{
      -ms-interpolation-mode:bicubic;
    }
    table{
      mso-table-lspace:0pt;
      mso-table-rspace:0pt;
    }
    .ReadMsgBody{
      width:100%;
    }
    .ExternalClass{
      width:100%;
    }
    p,a,li,td,blockquote{
      mso-line-height-rule:exactly;
    }
    a[href^=tel],a[href^=sms]{
      color:inherit;
      cursor:default;
      text-decoration:none;
    }
    p,a,li,td,body,table,blockquote{
      -ms-text-size-adjust:100%;
      -webkit-text-size-adjust:100%;
    }
    .ExternalClass,.ExternalClass p,.ExternalClass td,.ExternalClass div,.ExternalClass span,.ExternalClass font{
      line-height:100%;
    }
    a[x-apple-data-detectors]{
      color:inherit !important;
      text-decoration:none !important;
      font-size:inherit !important;
      font-family:inherit !important;
      font-weight:inherit !important;
      line-height:inherit !important;
    }
    a.mcnButton{
      display:block;
    }
    .mcnImage,.mcnRetinaImage{
      vertical-align:bottom;
    }
    .mcnTextContent{
      word-break:break-word;
    }
    .mcnTextContent img{
      height:auto !important;
    }
    .mcnDividerBlock{
      table-layout:fixed !important;
    }
    /*
    @tab Page
    @section background style
    @tip Set the background color and top border for your email. You may want to choose colors that match your company's branding.
    */
      body,#bodyTable,#templateFooter{
        /*@editable*/background-color:#002140;
      }
    /*
    @tab Page
    @section background style
    @tip Set the background color and top border for your email. You may want to choose colors that match your company's branding.
    */
      #bodyCell{
        /*@editable*/border-top:0;
      }
    /*
    @tab Page
    @section heading 1
    @tip Set the styling for all first-level headings in your emails. These should be the largest of your headings.
    @style heading 1
    */
      h1{
        /*@editable*/color:#FFFFFF !important;
        /*@editable*/font-family:Helvetica;
        /*@editable*/font-size:26px;
        /*@editable*/font-style:normal;
        /*@editable*/font-weight:bold;
        /*@editable*/line-height:125%;
        /*@editable*/letter-spacing:normal;
        /*@editable*/text-align:center;
      }
    /*
    @tab Page
    @section heading 2
    @tip Set the styling for all second-level headings in your emails.
    @style heading 2
    */
      h2{
        /*@editable*/color:#2D9CE8 !important;
        /*@editable*/font-family:Helvetica;
        /*@editable*/font-size:20px;
        /*@editable*/font-style:normal;
        /*@editable*/font-weight:bold;
        /*@editable*/line-height:125%;
        /*@editable*/letter-spacing:normal;
        /*@editable*/text-align:center;
      }
    /*
    @tab Page
    @section heading 3
    @tip Set the styling for all third-level headings in your emails.
    @style heading 3
    */
      h3{
        /*@editable*/color:#505050 !important;
        /*@editable*/font-family:Helvetica;
        /*@editable*/font-size:18px;
        /*@editable*/font-style:normal;
        /*@editable*/font-weight:bold;
        /*@editable*/line-height:125%;
        /*@editable*/letter-spacing:normal;
        /*@editable*/text-align:left;
      }
    /*
    @tab Page
    @section heading 4
    @tip Set the styling for all fourth-level headings in your emails. These should be the smallest of your headings.
    @style heading 4
    */
      h4{
        /*@editable*/color:#2D9CE8 !important;
        /*@editable*/font-family:Helvetica;
        /*@editable*/font-size:16px;
        /*@editable*/font-style:normal;
        /*@editable*/font-weight:bold;
        /*@editable*/line-height:125%;
        /*@editable*/letter-spacing:normal;
        /*@editable*/text-align:center;
      }
    /*
    @tab Page
    @section image card
    @tip Set the border radius of your email's image card blocks.
    */
      .mcnImageCardTopContent,.mcnImageCardRightContent,.mcnImageCardBottomContent,.mcnImageCardLeftContent{
        /*@editable*/border-radius:6px;
      }
    /*
    @tab Preheader
    @section preheader style
    @tip Set the background color and borders for your email's preheader area.
    */
      #templatePreheader{
        /*@editable*/background-color:#002D54;
        /*@editable*/border-top:0;
        /*@editable*/border-bottom:0;
      }
    /*
    @tab Preheader
    @section preheader text
    @tip Set the styling for your email's preheader text. Choose a size and color that is easy to read.
    */
      .preheaderContainer .mcnTextContent,.preheaderContainer .mcnTextContent p{
        /*@editable*/color:#FFFFFF;
        /*@editable*/font-family:Helvetica;
        /*@editable*/font-size:11px;
        /*@editable*/line-height:125%;
        /*@editable*/text-align:left;
      }
    /*
    @tab Preheader
    @section preheader link
    @tip Set the styling for your email's header links. Choose a color that helps them stand out from your text.
    */
      .preheaderContainer .mcnTextContent a{
        /*@editable*/color:#FFFFFF;
        /*@editable*/font-weight:normal;
        /*@editable*/text-decoration:underline;
      }
    /*
    @tab Header
    @section header style
    @tip Set the background color and borders for your email's header area.
    */
      #templateHeader{
        /*@editable*/background-color:#002140;
        /*@editable*/border-top:0;
        /*@editable*/border-bottom:0;
      }
    /*
    @tab Header
    @section header text
    @tip Set the styling for your email's header text. Choose a size and color that is easy to read.
    */
      .headerContainer .mcnTextContent,.headerContainer .mcnTextContent p{
        /*@editable*/color:#FFFFFF;
        /*@editable*/font-family:Helvetica;
        /*@editable*/font-size:18px;
        /*@editable*/line-height:150%;
        /*@editable*/text-align:center;
      }
    /*
    @tab Header
    @section header link
    @tip Set the styling for your email's header links. Choose a color that helps them stand out from your text.
    */
      .headerContainer .mcnTextContent a{
        /*@editable*/color:#FFFFFF;
        /*@editable*/font-weight:normal;
        /*@editable*/text-decoration:underline;
      }
    /*
    @tab Body
    @section body style
    @tip Set the background color and borders for your email's body area.
    */
      #templateBody{
        /*@editable*/background-color:#002140;
        /*@editable*/border-top:0;
        /*@editable*/border-bottom:0;
      }
    /*
    @tab Body
    @section body container
    @tip Set the background color and border radius for your email's body container. [Note: Border radius is not supported in all email clients.]
    */
      #bodyBackground{
        /*@editable*/background-color:#FFFFFF;
        /*@editable*/border-radius:5px;
      }
    /*
    @tab Body
    @section body text
    @tip Set the styling for your email's body text. Choose a size and color that is easy to read.
    */
      .bodyContainer .mcnTextContent,.bodyContainer .mcnTextContent p{
        /*@editable*/color:#303030;
        /*@editable*/font-family:Helvetica;
        /*@editable*/font-size:16px;
        /*@editable*/line-height:150%;
        /*@editable*/text-align:left;
      }
    /*
    @tab Body
    @section body link
    @tip Set the styling for your email's body links. Choose a color that helps them stand out from your text.
    */
      .bodyContainer .mcnTextContent a{
        /*@editable*/color:#2A9AE7;
        /*@editable*/font-weight:bold;
        /*@editable*/text-decoration:none;
      }
    /*
    @tab Footer
    @section footer text
    @tip Set the styling for your email's footer text. Choose a size and color that is easy to read.
    */
      .footerContainer .mcnTextContent,.footerContainer .mcnTextContent p{
        /*@editable*/color:#FFFFFF;
        /*@editable*/font-family:Helvetica;
        /*@editable*/font-size:11px;
        /*@editable*/line-height:125%;
        /*@editable*/text-align:left;
      }
    /*
    @tab Footer
    @section footer link
    @tip Set the styling for your email's footer links. Choose a color that helps them stand out from your text.
    */
      .footerContainer .mcnTextContent a{
        /*@editable*/color:#FFFFFF;
        /*@editable*/font-weight:normal;
        /*@editable*/text-decoration:underline;
      }
    @media only screen and (max-width: 480px){
      body,table,td,p,a,li,blockquote{
        -webkit-text-size-adjust:none !important;
      }
  
  }	@media only screen and (max-width: 480px){
      body{
        width:100% !important;
        min-width:100% !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .templateContainer{
        max-width:600px !important;
        width:100% !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnRetinaImage{
        max-width:100% !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnImage{
        height:auto !important;
        width:100% !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnCartContainer,.mcnCaptionTopContent,.mcnRecContentContainer,.mcnCaptionBottomContent,.mcnTextContentContainer,.mcnBoxedTextContentContainer,.mcnImageGroupContentContainer,.mcnCaptionLeftTextContentContainer,.mcnCaptionRightTextContentContainer,.mcnCaptionLeftImageContentContainer,.mcnCaptionRightImageContentContainer,.mcnImageCardLeftTextContentContainer,.mcnImageCardRightTextContentContainer,.mcnImageCardLeftImageContentContainer,.mcnImageCardRightImageContentContainer{
        max-width:100% !important;
        width:100% !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnBoxedTextContentContainer{
        min-width:100% !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnImageGroupContent{
        padding:9px !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnCaptionLeftContentOuter .mcnTextContent,.mcnCaptionRightContentOuter .mcnTextContent{
        padding-top:9px !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnImageCardTopImageContent,.mcnCaptionBottomContent:last-child .mcnCaptionBottomImageContent,.mcnCaptionBlockInner .mcnCaptionTopContent:last-child .mcnTextContent{
        padding-top:18px !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnImageCardBottomImageContent{
        padding-bottom:9px !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnImageGroupBlockInner{
        padding-top:0 !important;
        padding-bottom:0 !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnImageGroupBlockOuter{
        padding-top:9px !important;
        padding-bottom:9px !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnTextContent,.mcnBoxedTextContentColumn{
        padding-right:18px !important;
        padding-left:18px !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnImageCardLeftImageContent,.mcnImageCardRightImageContent{
        padding-right:18px !important;
        padding-bottom:0 !important;
        padding-left:18px !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcpreview-image-uploader{
        display:none !important;
        width:100% !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section heading 1
    @tip Make the first-level headings larger in size for better readability on small screens.
    */
      h1{
        /*@editable*/font-size:24px !important;
        /*@editable*/line-height:125% !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section heading 2
    @tip Make the second-level headings larger in size for better readability on small screens.
    */
      h2{
        /*@editable*/font-size:20px !important;
        /*@editable*/line-height:125% !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section heading 3
    @tip Make the third-level headings larger in size for better readability on small screens.
    */
      h3{
        /*@editable*/font-size:18px !important;
        /*@editable*/line-height:125% !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section heading 4
    @tip Make the fourth-level headings larger in size for better readability on small screens.
    */
      h4{
        /*@editable*/font-size:16px !important;
        /*@editable*/line-height:125% !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section Boxed Text
    @tip Make the boxed text larger in size for better readability on small screens. We recommend a font size of at least 16px.
    */
      .mcnBoxedTextContentContainer .mcnTextContent,.mcnBoxedTextContentContainer .mcnTextContent p{
        /*@editable*/font-size:18px !important;
        /*@editable*/line-height:125% !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section Preheader Visibility
    @tip Set the visibility of the email's preheader on small screens. You can hide it to save space.
    */
      #templatePreheader{
        /*@editable*/display:block !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section Preheader Text
    @tip Make the preheader text larger in size for better readability on small screens.
    */
      .preheaderContainer .mcnTextContent,.preheaderContainer .mcnTextContent p{
        /*@editable*/font-size:14px !important;
        /*@editable*/line-height:115% !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section Header Text
    @tip Make the header text larger in size for better readability on small screens.
    */
      .headerContainer .mcnTextContent,.headerContainer .mcnTextContent p{
        /*@editable*/font-size:18px !important;
        /*@editable*/line-height:125% !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section Body Text
    @tip Make the body text larger in size for better readability on small screens. We recommend a font size of at least 16px.
    */
      .bodyContainer .mcnTextContent,.bodyContainer .mcnTextContent p{
        /*@editable*/font-size:18px !important;
        /*@editable*/line-height:125% !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section footer text
    @tip Make the body content text larger in size for better readability on small screens.
    */
      .footerContainer .mcnTextContent,.footerContainer .mcnTextContent p{
        /*@editable*/font-size:14px !important;
        /*@editable*/line-height:115% !important;
      }
  
  }
    html {
			line-height: 1.15;
			-webkit-text-size-adjust: 100%;
			}
		body {
			margin: 0;
		}
		main {
			display: block;
		}
		h1 {
			font-size: 2em;
			margin: 0.67em 0;
		}
		hr {
			box-sizing: content-box;
				height: 0;
				overflow: visible;
		}

		pre {
			font-family: monospace, monospace;
			font-size: 1em;
		}

		a {
			background-color: transparent;
		}

		abbr[title] {
			border-bottom: none;
			text-decoration: underline;
			text-decoration: underline dotted;
		}
		b,
		strong {
			font-weight: bolder;
		}
		code,
		kbd,
		samp {
			font-family: monospace,
			monospace;
			font-size: 1em;
		}
		small {
			font-size: 80%;
		}
		sub,
		sup {
			font-size: 75%;
			line-height: 0;
			position: relative;
			vertical-align: baseline;
		}
		sub {
			bottom: -0.25em;
		}
		sup {
			top: -0.5em;
		}
		img {
			border-style: none;
		}
		button,
		input,
		optgroup,
		select,
		textarea {
			font-family: inherit;
			font-size: 100%;
			line-height: 1.15;
			margin: 0;
		}

		button,
		input {
				overflow: visible;
		}
		button,
		select {
			text-transform: none;
		}
		button,
		[type="button"],
		[type="reset"],
		[type="submit"] {
			-webkit-appearance: button;
		}
		button::-moz-focus-inner,
		[type="button"]::-moz-focus-inner,
		[type="reset"]::-moz-focus-inner,
		[type="submit"]::-moz-focus-inner {
			border-style: none;
			padding: 0;
		}
		button:-moz-focusring,
		[type="button"]:-moz-focusring,
		[type="reset"]:-moz-focusring,
		[type="submit"]:-moz-focusring {
			outline: 1px dotted ButtonText;
		}
		fieldset {
			padding: 0.35em 0.75em 0.625em;
		}
		legend {
			box-sizing: border-box;
			color: inherit;
			display: table;
			max-width: 100%;
			padding: 0;
			white-space: normal;
		}
		progress {
			vertical-align: baseline;
		}
		textarea {
			overflow: auto;
		}
		[type="checkbox"],
		[type="radio"] {
			box-sizing: border-box;
			padding: 0;
		}
		[type="number"]::-webkit-inner-spin-button,
		[type="number"]::-webkit-outer-spin-button {
			height: auto;
		}
		[type="search"] {
			-webkit-appearance: textfield;
			outline-offset: -2px;
		}
		[type="search"]::-webkit-search-decoration {
			-webkit-appearance: none;
		}
		::-webkit-file-upload-button {
			-webkit-appearance: button;
			font: inherit;
		}
		details {
			display: block;
		}
		summary {
			display: list-item;
		}
		template {
			display: none;
		}
		[hidden] {
			display: none;
		}
		.po-table {
			border-collapse: collapse;
			border-spacing: 0;
			width: 100%;
			border: 1px solid #ddd;
		}
		.po-table tr:nth-child(odd) {
			padding: 10px;
			background-color: #f9f9f9;
		}
		.po-table th {
			background-color: #e9ebf1;
			padding: 10px;

		}
		.po-table td {
			padding: 5px 10px;
		}
		.container {
      width: 85%;
      max-width: 960px;
			overflow: auto;
      padding: 25px;
      margin: 0 auto;
      box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12), 0 2px 4px -1px rgba(0, 0, 0, .2);
		}
		.align-right {
			text-align: right;
        }
        .tldr {
		
    	}
    	.tldr-title {

      }
      .summary-shipping {
        display: flex; 
        justify-content: space-between;
      }
    	.tldr-content {
	    	margin: 0 25px;
      }
      .review-button {
        height: 50px;
        border: 1px solid white;
        border-radius: .2rem;
        background-color: #192e5b;
        color: white;
        border: 0 solid black;
        padding: .5rem;
        box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12), 0 2px 4px -1px rgba(0, 0, 0, .2);
        cursor: pointer;
      }
  
      .review-button:hover {
        box-shadow:  0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12), 0 3px 5px -1px rgba(0, 0, 0, .2);
      }
  
      .review-button:active {
         transform: scaleY(.999);
      }
      .email-title {
        color: #505050 !important;
        text-align: left;
      }

</style></head>
    <body leftmargin="0" marginwidth="0" topmargin="0" marginheight="0" offset="0">
    <center>
    <table align="center" border="0" cellpadding="0" cellspacing="0" height="100%" width="100%" id="bodyTable">
        <tr>
            <td align="center" valign="top" id="bodyCell">
                <!-- BEGIN TEMPLATE // -->
                <table border="0" cellpadding="0" cellspacing="0" width="100%">
                    <tr>
                        <td align="center" valign="top">
                        </td>
                    </tr>
                    <tr>
                        <td align="center" valign="top">
                            <!-- BEGIN HEADER // -->
                            <table border="0" cellpadding="0" cellspacing="0" width="100%" id="templateHeader">
                                <tr>
                                    <td align="center" valign="top">
                                        <table border="0" cellpadding="0" cellspacing="0" width="1000" class="templateContainer">
                                            <tr>
                                                <td valign="top" class="headerContainer" style="padding-top:9px; padding-bottom:9px;"><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnDividerBlock" style="min-width:100%;">
<tbody class="mcnDividerBlockOuter">
<tr>
    <td class="mcnDividerBlockInner" style="min-width: 100%; padding: 9px 18px;">
        <table class="mcnDividerContent" border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width:100%;">
            <tbody><tr>
                <td>
                    <span></span>
                </td>
            </tr>
        </tbody></table>
<!--
        <td class="mcnDividerBlockInner" style="padding: 18px;">
        <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
-->
    </td>
</tr>
</tbody>
</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnImageBlock" style="min-width:100%;">
<tbody class="mcnImageBlockOuter">
    <tr>
        <td valign="top" style="padding:9px" class="mcnImageBlockInner">
            <table align="left" width="100%" border="0" cellpadding="0" cellspacing="0" class="mcnImageContentContainer" style="min-width:100%;">
                <tbody><tr>
                    <td class="mcnImageContent" valign="top" style="padding-right: 9px; padding-left: 9px; padding-top: 0; padding-bottom: 0;">




                    </td>
                </tr>
            </tbody></table>
        </td>
    </tr>
</tbody>
</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnDividerBlock" style="min-width:100%;">
<tbody class="mcnDividerBlockOuter">
<tr>
    <td class="mcnDividerBlockInner" style="min-width: 100%; padding: 9px 18px;">
        <table class="mcnDividerContent" border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width:100%;">
            <tbody><tr>
                <td>
                    <span></span>
                </td>
            </tr>
        </tbody></table>
<!--
        <td class="mcnDividerBlockInner" style="padding: 18px;">
        <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
-->
    </td>
</tr>
</tbody>
</table></td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                            <!-- // END HEADER -->
                        </td>
                    </tr>
                    <tr>
                        <td align="center" valign="top">
                            <!-- BEGIN BODY // -->
                            <table border="0" cellpadding="0" cellspacing="0" width="100%" id="templateBody">
                                <tr>
                                    <td align="center" valign="top" class="mobilePaddingRL5">
                                        <table border="0" cellpadding="0" cellspacing="0" width="1000" id="bodyBackground" class="templateContainer">
                                            <tr>
                                                <td align="center" valign="top">
                                                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                                                        <tr>
                                                            <td valign="top" class="bodyContainer" style="padding-top:9px; padding-bottom:9px;"><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnImageCardBlock">
</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnDividerBlock" style="min-width:100%;">
<tbody class="mcnDividerBlockOuter">
<tr>
    <td class="mcnDividerBlockInner" style="min-width: 100%; padding: 9px 18px;">
        <table class="mcnDividerContent" border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width:100%;">
            <tbody><tr>
                <td>
                    <span></span>
                </td>
            </tr>
        </tbody></table>
<!--
        <td class="mcnDividerBlockInner" style="padding: 18px;">
        <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
-->
    </td>
</tr>
</tbody>
</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">
<tbody class="mcnTextBlockOuter">
<tr>
    <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">
        <!--[if mso]>
<table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
<tr>
<![endif]-->

<!--[if mso]>
<td valign="top" width="1000" style="width:1000px;">
<![endif]-->
        <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">
            <tbody><tr>

                <td valign="top" class="mcnTextContent" style="padding-top:0; padding-right:18px; padding-bottom:9px; padding-left:18px;">
                  <h1 class="email-title">${title}</h1>
                  <br />
                  ${body}
                </td>
            </tr>
        </tbody></table>
<!--[if mso]>
</td>
<![endif]-->

<!--[if mso]>
</tr>
</table>
<![endif]-->
    </td>
</tr>
</tbody>
</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnDividerBlock" style="min-width:100%;">
<tbody class="mcnDividerBlockOuter">
<tr>
    <td class="mcnDividerBlockInner" style="min-width:100%; padding:18px;">
        <table class="mcnDividerContent" border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width: 100%;border-top: 1px solid #DDDDDD;">
            <tbody><tr>
                <td>
                    <span></span>
                </td>
            </tr>
        </tbody></table>
<!--
        <td class="mcnDividerBlockInner" style="padding: 18px;">
        <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
-->
    </td>
</tr>
</tbody>
</table></td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                            <!-- // END BODY -->
                        </td>
                    </tr>
                    <tr>
                        <td align="center" valign="top" style="padding-bottom:40px;">
                            <!-- BEGIN FOOTER // -->
                            <table border="0" cellpadding="0" cellspacing="0" width="100%" id="templateFooter">
                                <tr>
                                    <td align="center" valign="top">
                                        <table border="0" cellpadding="0" cellspacing="0" width="1000" class="templateContainer">
                                            <tr>
                                                <td valign="top" class="footerContainer" style="padding-top:9px; padding-bottom:9px;"><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnDividerBlock" style="min-width:100%;">
<tbody class="mcnDividerBlockOuter">
<tr>
    <td class="mcnDividerBlockInner" style="min-width: 100%; padding: 9px 18px;">
        <table class="mcnDividerContent" border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width:100%;">
            <tbody><tr>
                <td>
                    <span></span>
                </td>
            </tr>
        </tbody></table>
<!--
        <td class="mcnDividerBlockInner" style="padding: 18px;">
        <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
-->
    </td>
</tr>
</tbody>
</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">
<tbody class="mcnTextBlockOuter">
<tr>
    <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">
        <!--[if mso]>
<table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
<tr>
<![endif]-->

<!--[if mso]>
<td valign="top" width="1000" style="width:1000px;">
<![endif]-->
        <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">
            <tbody><tr>

                <td valign="top" class="mcnTextContent" style="padding-top:0; padding-right:18px; padding-bottom:9px; padding-left:18px;">

                    
<br>

                </td>
            </tr>
        </tbody></table>
<!--[if mso]>
</td>
<![endif]-->

<!--[if mso]>
</tr>
</table>
<![endif]-->
    </td>
</tr>
</tbody>
</table></td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                            <!-- // END FOOTER -->
                        </td>
                    </tr>
                </table>
                <!-- // END TEMPLATE -->
            </td>
        </tr>
    </table>
</center>
    </body>
</html>`;
// C-022 <em>Copyright © 2018 TMP Portal, All rights reserved.</em> in L- 1079
// export const getDistributorPOEmailTemplate = (
//   subject: string,
//   title: string,
//   body: string
// ) => `<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office>
// <head>
//   <meta charset="UTF-8">
//   <meta http-equiv="X-UA-Compatible" content="IE=edge">
//   <meta name="viewport" content="width=device-width, initial-scale=1">
//   <style type="text/css">
//   </style>
// </head>
// <body>
//   <div class="container" style="font-family: Arial, Helvetica, sans-serif; width: 85%;max-width: 960px;overflow: auto;padding: 25px;margin: 0 auto;box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12), 0 2px 4px -1px rgba(0, 0, 0, .2);">
//     <table align="center" border="0" cellpadding="0" cellspacing="0" height="100%" width="100%" id="bodyTable" style="border-collapse: collapse;mso-table-lspace: 0pt;mso-table-rspace: 0pt;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;height: 100%;margin: 0;padding: 0;width: 100%;">
//       <h1 style="display: block;margin: 0.67em 0;padding: 0;font-size: 2em;">${title}</h1>
//         <p style="margin: 10px 0;padding: 0;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;">PO request to IPGP for the medications specified below:</p>
//         <p style="margin: 10px 0;padding: 0;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;">Please send an invoice to [placeholderemail@test.com]</p>
//           <br />
//             ${body}
//     </table>
//   </div>
// </body>
// </html>
// `;



//////////////////
// WEBPACK FOOTER
// ./src/shared/po-distributor-email-template.ts
// module id = 3100
// module chunks = 0